import mixpanel from 'mixpanel-browser'
import { AddEvent } from '~/passporter-services/shared/metrics'
import { BaseMetric } from './baseMetric'

export class TripLeadMetric extends BaseMetric {
	public static addLead(destination: string, tripId: string, routeName?: string): void {
		new AddEvent('lead', routeName)
			.addParam('trip_id', tripId)
			.addParam('trip_destination', destination)
			.send(this.gtag, mixpanel)
	}
}
